import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl } from "../utils/config";

import Loader from "./layouts/Loader";

function Followings() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    
    async function onInit() {
        setLoading(true);

        try {
            const formData = new FormData();
            formData.append("type", "recruiter");

            const response = await axios.post(
                baseUrl + "/api/followers/fetch",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setData(response.data.data);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    async function removeFollow(event, id) {
        const node = event.target;
        node.setAttribute("disabled", "disabled");

        try {
            const formData = new FormData();
            formData.append("id", id);

            const response = await axios.post(
                baseUrl + "/api/followers/remove",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const temp = [ ...data ];
                for (let a = 0; a < temp.length; a++) {
                    if (temp[a].id == id) {
                        temp.splice(a, 1);
                        break;
                    }
                }
                setData(temp);
            } else {
                swal.fire("Error", response.data.message, "error");
                node.removeAttribute("disabled");
            }
        } catch (exp) {
            console.log(exp.message);
            node.removeAttribute("disabled");
        }
    }

    useEffect(function () {
        onInit();
    }, []);

    const styles = {
        profileImage: {
            width: "100px"
        }
    };

    return (
        <>
            <div className="container-xxl bg-dark">
                <div className="container pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Followings</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">Followings</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Followings</h1>
                    <div className="row g-4">
                        <div className="col-md-12">
                            <div className="wow fadeInUp" data-wow-delay="0.5s">

                                { loading && (
                                    <div className="text-center mb-3">
                                        <Loader />
                                    </div>
                                ) }

                                <div className="row mb-3">
                                    { data.map(function (n) {
                                        return (
                                            <div className="col-md-4" key={ `data-${ n.id }` }>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="row mb-3">
                                                            { n.profile_image != "" && (
                                                                <div className="col-md-4">
                                                                    <img src={ n.profile_image }
                                                                        style={ styles.profileImage } />
                                                                </div>
                                                            ) }

                                                            <div className="col-md-8">
                                                                <h2>
                                                                    <Link to={ `/recruiter/${ n.company_id }` }>
                                                                        { n.name }
                                                                    </Link>
                                                                </h2>

                                                                <button type="button" className="btn btn-outline-danger"
                                                                    onClick={ function (event) {
                                                                        removeFollow(event, n.id);
                                                                    } }>Unfollow</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }) }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Followings;